import axios from 'axios';
import localStorageService from 'helpers/localStorageService';
import { MIDDLEWARE_API_BASE_URL, REQUEST_TIMEOUT } from 'constants/config';

// Types for middleware authenticate response
export type MiddlewareAuthResponse = {
  payload?: {
    id_token?: string;
    [k: string]: unknown;
  };
  [k: string]: unknown;
};

const middlewareRequest = axios.create({
  baseURL: MIDDLEWARE_API_BASE_URL || 'https://middleware.logeld.com',
  timeout: REQUEST_TIMEOUT,
});

export const authenticateWithMiddleware = async (username: string, password: string): Promise<string | null> => {
  try {
    const res = await middlewareRequest.post<MiddlewareAuthResponse>('/api/authenticate', {
      username,
      password,
    });
    const token = res?.data?.payload?.id_token || null;
    return token;
  } catch (e) {
    // Non-blocking: if middleware fails, we return null and let caller decide
    return null;
  }
};

export type SubmitFmcsaRequest = {
  driverId: string;
  tenantId: string;
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
  code: string;
};

export const submitFmcsa = async (payload: SubmitFmcsaRequest) => {
  const token = localStorageService.get<string>('middlewareToken');
  if (!token) {
    throw new Error('Missing middleware token. Please log out and log in again.');
  }
  const res = await middlewareRequest.post('/api/fmcsa/submit', payload, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });
  return res.data;
};

export default { authenticateWithMiddleware, submitFmcsa };
